export const PACKAGE_STATUS_NOT_SUBSCRIBE = 0
export const CANDIDATE_STATUS_PACKAGE = 1
export const PACKAGE_STATUS_PACKAGE = 2
export const PACKAGE_STATUS_SUSPENDED = 3
export const PACKAGE_STATUS_NOT_CANDIDATE = 'not_candidate'
export const PACKAGE_STATUS_CANDIDATE = 'candidate'
